module.exports = __webpack_public_path__ + "static/media/no-dialogs.f98d5619.png";